import React from 'react'

import BlockContent from '~/components/atoms/BlockContent/BlockContent'
import Container from '~/components/atoms/Container/Container'
import Fixture from '~/components/atoms/Fixture/Fixture'
import type { ImageProps } from '~/components/atoms/Image/Image'
import SpecificImage from '~/components/atoms/SpecificImage/SpecificImage'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import type { ComponentTheme } from '~/components/themes'

import styles from './OurMissionHero.module.css'

interface OurMissionHeroProps {
  sections: {
    title?: string
    summary: any // richText
  }[]
  verticalPadding?: boolean
  noPaddingBottom?: boolean
  image: ImageProps
  sideText: string
  items: {
    label: string
    text: string
  }[]
  theme: ComponentTheme
  moduleId?: string
}

export default function OurMissionHero({
  sections,
  image,
  sideText,
  items,
  verticalPadding,
  noPaddingBottom,
  theme,
  moduleId,
}: OurMissionHeroProps) {
  return (
    <Fixture
      verticalPadding={verticalPadding}
      theme={theme}
      noPaddingBottom={noPaddingBottom}
      id={moduleId}
    >
      <div className={styles.base}>
        <Container>
          <div className={styles.container}>
            <div className={styles.content}>
              <div className={styles.sections}>
                {sections.map((section, index) => (
                  <div key={index} className={styles.section}>
                    <Text
                      size={TextSizes.primaryTitleLrg}
                      className={styles.sectionTitle}
                    >
                      {section.title}
                    </Text>

                    <div className={styles.sectionSummary}>
                      <BlockContent value={section.summary} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className={styles.sidebar}>
              <div className={styles.imageContainer}>
                <SpecificImage
                  asset={image.asset}
                  alt="Our Mission"
                  width={400}
                />
              </div>
              <Text size={TextSizes.bodyMed} className={styles.sideText}>
                {sideText}
              </Text>
              <div className={styles.items}>
                {items.map((item, index) => (
                  <div key={index} className={styles.item}>
                    <Text
                      size={TextSizes.primaryTitleMed}
                      className={styles.itemLabel}
                    >
                      {item.label}
                    </Text>
                    <Text
                      size={TextSizes.secondaryTitleLrg}
                      className={styles.itemText}
                    >
                      {item.text}
                    </Text>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Container>
      </div>
    </Fixture>
  )
}
